import { UserAuthWrapper } from 'redux-auth-wrapper';
import { replace } from '../services/router-utils';

/* eslint-disable */
const requireNotBlocked = UserAuthWrapper({
  authSelector: state => state.auth.currentUser,
  predicate: user => !user.isBlocked,
  failureRedirectPath: '/account-suspended',
  wrapperDisplayName: 'requireNotBlocked',
  redirectAction: replace,
  allowRedirectBack: false,
});
/* eslint-enable */

export default requireNotBlocked;



// WEBPACK FOOTER //
// ./app/hoc/require-not-blocked.js